<div fxLayout="row" fxLayoutAlign="space-between center">
  <h2 mat-dialog-title>Add Workflow</h2>
  <button class="pos-right btn-plane cursor mr-1" (click)="onCancel()">
    <em class="fa fa-times" aria-hidden="true"></em>
  </button>
</div>

<div mat-dialog-content class="dialog-content">
  <!-- Workflow Name Dropdown -->
  <mat-form-field>
    <mat-label>{{wfName}}</mat-label>
    <mat-select [(ngModel)]="selectedWorkflow" (ngModelChange)="onWorkflowSelected()"
      [disabled]="this.data.mode === 'read'">
      <mat-option *ngFor="let workflow of workflows" [value]="workflow">{{ workflow.wfName }}</mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Target Dropdown -->
  <mat-form-field class="target-dropdown" appearance="fill">
    <mat-label>{{target}}</mat-label>
    <mat-select [(ngModel)]="selectedTarget" [disabled]="!selectedWorkflow || this.data.mode === 'read'">
      <mat-option *ngFor="let workflow of targetWfs" [value]="workflow">
        {{ workflow.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>

<div class="button-container" *ngIf="!showAdditionalFields">
  <button class="dialog-content" mat-icon-button color="primary" *ngIf="selectedWorkflow && this.data.mode != 'read'"
    (click)="addNewField()" [disabled]="!selectedWorkflow">
    <mat-icon>add</mat-icon>
  </button>
</div>

<div class="additional-fields" *ngIf="showAdditionalFields" [formGroup]="additionalFieldsForm">
  <div class="checkbox-wrapper">
    <mat-checkbox formControlName="latest" color="primary">Take latest</mat-checkbox>
  </div>
  <div class="inputFields">
    <mat-form-field class="example-full-width">
      <input matInput formControlName="key" maxlength="256" placeholder="Key">
    </mat-form-field>
    <mat-form-field class="example-full-width">
      <input matInput formControlName="description" maxlength="256" placeholder="Description">
    </mat-form-field>
    <mat-form-field class="example-full-width">
      <input matInput formControlName="value" maxlength="256" placeholder="Value">
    </mat-form-field>
    <mat-icon color="primary" (click)="saveNewField()">save</mat-icon>
    <mat-icon color="warn" (click)="cancelNewField()">cancel</mat-icon>
  </div>
</div>

<div class="parameters" *ngIf="selectedWorkflow">
  <div *ngFor="let output of selectedWorkflow.outputs">
    <h3 class="output-key">{{ output.key }}
      <span><mat-checkbox [(ngModel)]="output.checked" color="primary">Take latest</mat-checkbox></span>
    </h3>

    <mat-form-field class="example-full-width">
      <input matInput [(ngModel)]="output.value" maxlength="256" [placeholder]="output.key" [disabled]="output.checked">
      <mat-hint align="start">{{ output.description }}</mat-hint>
    </mat-form-field>
  </div>

  <div *ngFor="let field of additionalFields">
    <h3>{{ field.key }}
      <span><mat-checkbox [(ngModel)]="field.latest" color="primary">Take latest</mat-checkbox></span>
    </h3>
    <mat-form-field class="example-full-width">
      <input matInput [(ngModel)]="field.value" maxlength="256" [placeholder]="field.key" [disabled]="field.latest">
      <mat-hint align="start">{{ field.description }}</mat-hint>
    </mat-form-field>
  </div>

  <ng-container *ngIf="selectedWorkflow">
    <div *ngFor="let input of inputValues | keyvalue">
      <h3>{{ input.key }}</h3>
      <mat-form-field class="example-full-width">
        <input matInput [(ngModel)]="input.value" maxlength="256" [placeholder]="input.key">
      </mat-form-field>
    </div>
  </ng-container>
</div>

<div mat-dialog-actions class="iw-button" *ngIf="this.data.mode === 'edit' || this.data.mode === 'add'">
  <button mat-raised-button color="primary" (click)="onSave()" [disabled]="!workflowSelected">Save</button>
  <button mat-raised-button (click)="onCancel()">Cancel</button>
</div>